import {
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST,
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_SUCCESS,
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_FAILURE,
  FETCH_ORDER_ENTRY_ALLVENDORS_SUCCESS,
  FETCH_ORDER_ENTRY_ALLVENDORS_FAILURE,
  FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST,
} from "./actionTypes";
import { CustomersState, VendorsState } from "./types";
import { combineReducers } from "redux";

const customersInitialState: CustomersState = {
  customers: [],
  loadingScreen: false,
  error: null,
  successMessage: "",
  pending: false,
  totalCount: 0,
  dropdownCustomers: [],
};

const vendorsInitialState: VendorsState = {
  vendors: [],
  loadingScreen: false,
  error: null,
  successMessage: "",
  pending: false,
  totalCount: 0,
  dropdownVendors: [],
};

// Customers reducer
export const customersReducer = (
  state = customersInitialState,
  action: any
): CustomersState => {
  switch (action.type) {
    case FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };

    case FETCH_ORDER_ENTRY_ALLCUSTOMERS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        customers: action.payload.customers,
        totalCount: action.payload.totalCount,
      };

    case FETCH_ORDER_ENTRY_ALLCUSTOMERS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Vendors reducer
export const vendorsReducer = (
  state = vendorsInitialState,
  action: any
): VendorsState => {
  switch (action.type) {
    case FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };

    case FETCH_ORDER_ENTRY_ALLVENDORS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        vendors: action.payload.vendors,
        totalCount: action.payload.totalCount,
      };

    case FETCH_ORDER_ENTRY_ALLVENDORS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

const allCustomersVendorsReducer = combineReducers({
  customers: customersReducer,
  vendors: vendorsReducer,
});

export default allCustomersVendorsReducer;
